export default "__VITE_ASSET__1f30d0f9__"